var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column-layout" }, [
    _vm.confKey == null
      ? _c(
          "div",
          [
            _c("swb-query-sort-area", {
              ref: "query_model_ctrl",
              attrs: {
                config: _vm.queryConfig,
                queryKey: _vm.queryKey,
                onConfigReady: _vm.onConfigReady,
                queryHandler: _vm.queryHandler,
                popupHandler: _vm.popupHandler,
                eventHandler: _vm.eventHandler
              }
            }),
            _vm._v(" "),
            _vm.checkBox
              ? _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.comList, border: "" },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _vm.checkBox
                          ? _c("el-table-column", {
                              attrs: {
                                type: "selection",
                                selectable: _vm.canSelectRow,
                                width: "55",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filter != null && !_vm.filter.filterMerchantId
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "merchantName",
                                label: "商户名称",
                                align: "left",
                                width: "200",
                                "show-overflow-tooltip": ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizUnitName",
                            label: "业务单元",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "业务部门",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _vm.showTag
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "tagName",
                                label: "机构标签",
                                align: "left",
                                width: "120"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.tagId != null
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [_vm._v(_vm._s(rows.row.tagName))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactName",
                            label: "联系人",
                            align: "left",
                            width: "120"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactTel",
                            label: "联系电话",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mgmtBigAreaName",
                            label: "管理大区",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mgmtSmlAreaName",
                            label: "管理小区",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizAreaName",
                            label: "经营区域",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizAreaName",
                            label: "经营区域",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizFormName",
                            label: "经营业态",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "地址",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.regionName != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(rows.row.regionName))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.street != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(rows.row.street))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgType",
                            label: "机构类型",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgType == 0
                                    ? _c("span", [_vm._v("业务部门")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.orgType == 1
                                    ? _c("span", [_vm._v("业务单元")])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "业务单元级别",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTransComLevel(
                                          rows.row.bizUnitLevel
                                        )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.comList,
                          border: "",
                          "highlight-current-row": ""
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { width: "55" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "copy-radio",
                                      class: {
                                        circle:
                                          _vm.checkComInfo != null &&
                                          _vm.checkComInfo.id == rows.row.id
                                      }
                                    },
                                    [_c("div", { staticClass: "circle-dot" })]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizUnitName",
                            label: "业务单元",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "业务部门",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _vm.showTag
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "tagName",
                                label: "机构标签",
                                align: "left",
                                width: "110"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(rows) {
                                    return [
                                      rows.row.tagId != null
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [_vm._v(_vm._s(rows.row.tagName))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ])
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactName",
                            label: "联系人",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "contactTel",
                            label: "联系电话",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mgmtBigAreaName",
                            label: "管理大区",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mgmtSmlAreaName",
                            label: "管理小区",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizAreaName",
                            label: "经营区域",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "bizFormName",
                            label: "经营业态",
                            align: "center",
                            width: "110"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "地址",
                            align: "left",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.regionName != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(rows.row.regionName))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.street != null
                                    ? _c("span", [
                                        _vm._v(_vm._s(rows.row.street))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "orgType",
                            label: "机构类型",
                            align: "left",
                            width: "200",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgType == 0
                                    ? _c("span", [_vm._v("业务部门")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rows.row.orgType == 1
                                    ? _c("span", [_vm._v("业务单元")])
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "业务单元级别",
                            align: "center",
                            width: "100"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getTransComLevel(
                                          rows.row.bizUnitLevel
                                        )
                                      )
                                    )
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block pagination-layout" },
              [
                _c("el-pagination", {
                  staticClass: "mt10",
                  attrs: {
                    background: "",
                    "page-size": _vm.pageSize,
                    "page-sizes": _vm.pageSizes,
                    "current-page": _vm.pageNumber,
                    total: _vm.totalCount,
                    layout: "total, sizes, prev, pager, next, jumper"
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "div",
              { attrs: { name: "query-sort-block" } },
              [
                _c("swb-query-sort-area", {
                  ref: "query_model_ctrl",
                  attrs: {
                    confKey: _vm.confKey,
                    configAuto: true,
                    queryOnLoad: _vm.queryOnLoad,
                    queryHandler: _vm.queryHandlerForKey
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("swb-result-table", {
              ref: "result_table",
              attrs: {
                name: "result_table",
                btnColBaseCount: 2,
                btnColMoreTitle: "更多操作",
                confKey: _vm.confKey,
                configAuto: true,
                needPager: _vm.needPager,
                multiSelect: _vm.multiSelect,
                multiPageSelect: _vm.multiPageSelect,
                rowKeyPropName: _vm.rowKeyPropName,
                rowNoShow: _vm.rowNoShow,
                rowNoFixed: _vm.rowNoFixed,
                btnColName: _vm.btnColName,
                btnColTitle: _vm.btnColTitle,
                btnColWidth: _vm.btnColWidth,
                btnColFixed: _vm.btnColFixed,
                height: _vm.theTableHeight,
                pageNoChangeHandler: _vm.pageNoChangeHandler,
                rowDblClickHandler: _vm.rowDblClickHandler
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14d10410", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d10410","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/RetailerComListForSelect.vue
// module id = 2751
// module chunks = 0